import type { UndoCommand, CommandContext } from "../types";

/**
 * Command for "Reconnect stages": un-flags a pair in
 * state.disconnectedStageIds after the user pulls a stage's start back onto
 * the previous stage's end. The marker move itself is tracked by the
 * MoveMarkerCommand that markerMoved() pushes separately — this command only
 * restores the disconnected flag on undo, and only exists at all when the
 * pair had actually been disconnected (see reconnectStages in
 * drag-preview.ts).
 */
export class ReconnectStagesCommand implements UndoCommand {
  readonly type: string = 'RECONNECT_STAGES';
  readonly routeKey: string | null = null;

  constructor(private connectorId: string) {}

  undo(ctx: CommandContext): void {
    if (!ctx.state.disconnectedStageIds.includes(this.connectorId)) {
      ctx.state.disconnectedStageIds.push(this.connectorId);
    }
  }

  redo(ctx: CommandContext): void {
    ctx.state.disconnectedStageIds =
      ctx.state.disconnectedStageIds.filter(id => id !== this.connectorId);
  }
}
